"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageOutputDtoSchema = exports.getPackageInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const hil_package_js_1 = require("../../types/hil-package.js");
exports.getPackageInputDtoSchema = z.object({
    id: z.string(),
});
exports.getPackageOutputDtoSchema = z.object({
    pkg: hil_package_js_1.HilPackage.schema,
    isConfidential: z
        .boolean()
        .describe('Whether the package belongs to a confidential, customer-owned package family. Derived from the family owner, not from the datasheet file owner.'),
    datasheetValidation: cadstrom_shared_1.PackageDatasheetValidationSchema.extend({
        workflowUrl: z.string().nullable(),
    })
        .nullable()
        .describe('The datasheet–MPN validation verdict for the currently attached file, or null when there is none.'),
    datasheetProvenance: cadstrom_shared_1.PackageDatasheetProvenanceSchema.nullable().describe('Where the currently attached file came from when it was not fetched for this part number, or null when it was.'),
});
//# sourceMappingURL=get-package.dto.js.map